import HeaderStyles from '@stories/Widgets/Header/Header.styles';
/**
 * Scroll to target selector or element.
 */
export function scrollTo(target, offset = 0) {
    const targetElement = getTargetElement(target);
    // Get header height for offset.
    const headerElement = document.querySelector(HeaderStyles.Container);
    const headerHeight = headerElement?.getBoundingClientRect()?.height ?? 0;
    // Calculate target scroll position.
    const targetOffset = targetElement?.offsetTop ?? 0;
    const scrollTo = targetOffset - headerHeight + offset;
    window.scrollTo({
        behavior: 'smooth',
        top: scrollTo,
    });
}
/**
 * Get target element if selector, otherwise return provided element.
 */
function getTargetElement(target) {
    if (typeof target === 'string') {
        return document.querySelector(target);
    }
    else {
        return target;
    }
}
